(() => {
  const variantIds = {
    1: '63783625621834',
    2: '63783625654602',
    3: '63783625687370',
  };
  const bundles = [...document.querySelectorAll('#bundles .bundle')];
  const ctas = ['mainCta', 'closeCta', 'stickyBtn'].map((id) => document.getElementById(id)).filter(Boolean);
  const cartUrl = document.getElementById('db7-routes')?.dataset.cartUrl || '/cart';
  const country = document.getElementById('db7-routes')?.dataset.country || 'DK';
  let selected = bundles.find((bundle) => bundle.classList.contains('sel')) || bundles[0];

  const select = (bundle) => {
    selected = bundle;
    bundles.forEach((item) => {
      item.classList.toggle('sel', item === bundle);
      item.setAttribute('aria-pressed', String(item === bundle));
    });
    const variantId = variantIds[Number(bundle.dataset.qty)];
    const target = /^\d+$/.test(variantId)
      ? `${cartUrl}/${variantId}:1?checkout&checkout[shipping_address][country]=${encodeURIComponent(country)}`
      : '#offer';
    ctas.forEach((link) => { link.href = target; });
    for (const id of ['ctaNew', 'cNew']) {
      const element = document.getElementById(id);
      if (element) element.textContent = bundle.dataset.total;
    }
    for (const id of ['ctaOld', 'cOld']) {
      const element = document.getElementById(id);
      if (element) {
        element.textContent = bundle.dataset.old || '';
        element.hidden = !bundle.dataset.old;
      }
    }
  };
  bundles.forEach((bundle) => {
    bundle.addEventListener('click', () => select(bundle));
    bundle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        select(bundle);
      }
    });
  });
  if (selected) select(selected);

  const track = document.getElementById('gtrack');
  const thumbs = [...document.querySelectorAll('#thumbs img')];
  let slide = 0;
  const showSlide = (index) => {
    slide = Math.max(0, Math.min(thumbs.length - 1, index));
    if (track) track.style.transform = `translateX(-${slide * 100}%)`;
    thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === slide));
    const previous = document.getElementById('gprev');
    const next = document.getElementById('gnext');
    if (previous) previous.style.visibility = slide === 0 ? 'hidden' : 'visible';
    if (next) next.style.visibility = slide === thumbs.length - 1 ? 'hidden' : 'visible';
  };
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
  document.getElementById('gprev')?.addEventListener('click', () => showSlide(slide - 1));
  document.getElementById('gnext')?.addEventListener('click', () => showSlide(slide + 1));

  document.querySelectorAll('.faq .item .q').forEach((question) => {
    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    const toggle = () => question.parentElement.classList.toggle('open');
    question.addEventListener('click', toggle);
    question.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  });
})();
